export default "__VITE_PUBLIC_ASSET__ea92a29c__"